import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { logger } from '../../lib/logger';

interface LoadingIndicatorProps {
  config?: any;
  translations?: Record<string, Record<string, string>>;
  timeout?: number;
  containerClassName?: string;
  id?: string;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ 
  config,
  translations = {},
  timeout = 30000, // 30 secondes par défaut
  containerClassName = "fixed inset-0 bg-white bg-opacity-90 z-50",
  id = "default-loader"
}) => {
  const color = config?.['major-color'] || '#6B7280';
  const loadingText = translations?.['loading_data']?.['fr'] || 'Chargement...';

  useEffect(() => {
    const timer = setTimeout(() => {
      logger.warn(`Loading timeout reached for: ${id}`, {
        category: 'UI',
        data: {
          id,
          timeout,
          timestamp: new Date().toISOString()
        }
      });
      // Ne pas recharger automatiquement la page, cela peut causer des boucles
      // window.location.reload();
    }, timeout);

    return () => {
      clearTimeout(timer);
    };
  }, [timeout, id, config]);

  return (
    <div className={containerClassName} data-testid={`loading-indicator-${id}`}>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="relative">
          <Loader2 
            size={48} 
            className="animate-spin"
            style={{ color }}
          />
        </div>
        {loadingText && (
          <p 
            className="mt-4 text-lg font-medium"
            style={{ color }}
          >
            {loadingText}
          </p>
        )}
      </div>
    </div>
  );
};